import React from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider } from 'pure-react-carousel';
import AmexExperientialBannerCarousel from '../AmexExperientialBannerCarousel';
import AmexExperientialBannerCarouselSlide from '../AmexExperientialBannerCarousel/AmexExperientialBannerCarouselSlide';
import './AmexExperientialBanner.scss';

const MAX_SLIDES = 5;

const AmexExperientialBanner = (
  {
    matchMedia,
    baseRequestUrl,
    bannerConfig,
    Analytics,
    scrollTo,
  }
) => {
  if (!bannerConfig?.content || bannerConfig.content.length === 0) return false;

  const singleSlideProps = {
    index: 1,
    currentSlide: false,
    image: bannerConfig.content[0].image,
    retina_image: bannerConfig.content[0].retina_image,
    header: bannerConfig.content[0].header,
    copy: bannerConfig.content[0].copy,
    cta: bannerConfig.content[0].cta,
    baseRequestUrl,
    Analytics,
    matchMedia,
  };

  const sortedCarouselData = bannerConfig.content
    .sort((a, b) => {
      if (a?.orderId && b?.orderId) return a.orderId > b.orderId ? 1 : -1;
      return a?.orderId ? -1 : 1;
    })
    .slice(0, MAX_SLIDES);

  return (
    <>
      {bannerConfig.content.length > 1 ? (
        <div className="AmexExperientialBanner">
          <CarouselProvider
            isIntrinsicHeight
            naturalSlideHeight="100%"
            naturalSlideWidth="100%"
            totalSlides={sortedCarouselData.length}
            touchEnabled
            dragEnabled={false}
          >
            <AmexExperientialBannerCarousel
              bannerConfig={bannerConfig}
              sortedCarouselData={sortedCarouselData}
              baseRequestUrl={baseRequestUrl}
              Analytics={Analytics}
              matchMedia={matchMedia}
              scrollTo={scrollTo}
            />
          </CarouselProvider>
        </div>
      ) : (
        <div className="AmexExperientialBanner single">
          <AmexExperientialBannerCarouselSlide
            {...singleSlideProps}
          />
        </div>
      )}
    </>
  );
};

AmexExperientialBanner.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  bannerConfig: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.shape({
        desktop: PropTypes.string,
        mobile: PropTypes.string,
      }).isRequired,
      retina_image: PropTypes.shape({
        desktop: PropTypes.string,
        mobile: PropTypes.string,
      }),
      header: PropTypes.string.isRequired,
      copy: PropTypes.string.isRequired,
      cta: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
      }),
    })),
  }),
  matchMedia: PropTypes.shape({}).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  scrollTo: PropTypes.func.isRequired,
};

AmexExperientialBanner.defaultProps = {
  bannerConfig: {
    content: [{
      cta: null,
      retina_image: null,
    }],
  },
};

export default AmexExperientialBanner;
